export const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: "job-hunter-110ae.firebaseapp.com",
    projectId: "job-hunter-110ae",
    storageBucket: "job-hunter-110ae.appspot.com",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
    databaseURL: "https://job-hunter-110ae-default-rtdb.europe-west1.firebasedatabase.app",
}